import { type Stacklet } from '@/entities/stacklet';
import request from '@/shared/api/request';

export const rebuildStacklet = (id: number, image: string): Promise<{ stacklet: Stacklet }> =>
  request({
    url: `/stacklets/${id}/`,
    method: 'POST',
    data: { image, action: 'rebuild' },
  });
